import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Card, Descriptions, Tag, Button, Tabs, Spin, message, Space, Modal, Input, Form } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { apiRequest } from '../../api';
import PageHeader from '../../components/PageHeader';

const statusColors = {
	Pending: 'orange',
	Active: 'green',
	Suspended: 'red',
	Declined: 'volcano',
};

const TenantDetail = () => {

	const user = {
		id: 13,
		name: "vikas k",
		profile: null,
		email: "vikas32K@zluck.in",
		country_code: "91",
		phone: "0000000000",
		isVerified: true,
		status: "active",
		tenant: {
			id: 10,
			name: "Vk Solution ",
			logo: "1753267306116.jpg",
			tenant_type: "Private",
			team_strength: "200+",
			status: "active",
		},
		role: {
			name: "Manager",
		}
	};

	return (
		<>
			<section className="dashboard-page main-layout-page main-layout h-[calc(100vh-50px)]">
				<div className="!p-0">
					<div className="main-layout-wrapper bg-white h-screen flex flex-col sticky z-1 top-0">
						<PageHeader
							title="Tenant Detail"
							description="Plan, prioritize, and accomplish your companies with us."
							onOpenSidebar={() => setIsSidebarOpen(true)}
						/>

						<div className="flex items-baseline gap-[40px] main-sidebar-wrapper flex-1">
							<div className="flex-1 right-sidebar h-full relative">
								<div className="right-sidebar-contend py-6 px-3 md:ps-[24px] md:p-6 md:pb-[50px] md:ps-0 h-full">
									<div className='grid md:grid-cols-2 gap-6'>
									<div className="bg-white box-shadow p-5 space-y-7 rounded-md rounded-md">
										<h2 className="text-h4 text-blue">Tenant Detail</h2>
										<div className="flex items-start gap-4">
											{user.profile ? (
												<img
													src={user.profile}
													alt={user.name}
													className="w-16 h-16 rounded-full object-cover border"
												/>
											) : (
												<div className="w-16 h-16 bg-blue rounded-full flex items-center justify-center text-xl font-bold text-white">
													{user.name?.[0]?.toUpperCase() || "U"}
												</div>
											)}

											<div className='space-y-2'>
												<h2 className="text-p text-black mb-0 !font-bold">{user.name}</h2>
												<p className="text-sub_span !font-medium text-[#454545]">{user.email}</p>
												<p className="text-sub_span !font-medium text-[#454545]">
													+{user.country_code} {user.phone}
												</p>
												{user.isVerified && (
													<span className="text-sub_span !font-medium text-[#00D261] flex items-center gap-2">
														<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
															<path d="M7.21773 16.0976C10.5924 16.0976 13.328 13.3619 13.328 9.98726C13.328 6.61263 10.5924 3.87695 7.21773 3.87695C3.8431 3.87695 1.10742 6.61263 1.10742 9.98726C1.10742 13.3619 3.8431 16.0976 7.21773 16.0976Z" fill="#B0EF8F" />
															<path d="M7.28716 14.7105L7.20965 14.5784C6.02581 12.5614 2.87989 8.2809 2.84812 8.23791L2.80273 8.17626L3.87453 7.11703L7.26725 9.48607C9.4034 6.71411 11.3963 4.81019 12.6962 3.69838C14.1183 2.48217 15.0439 1.92226 15.0533 1.9169L15.0743 1.9043H16.8924L16.7187 2.05896C12.2523 6.03717 7.41122 14.4925 7.363 14.5774L7.28716 14.7105Z" fill="#009045" />
														</svg>
														Verified
													</span>
												)}
											</div>
										</div>
									</div>

									<div className="bg-white box-shadow p-5 space-y-7 rounded-md rounded-md">
										<h2 className="text-h4 text-blue">Company Information</h2>
										<div className='list space-y-3'>
											<div className='flex items-center gap-2 text-sub_span text-[#454545]'><span className='!font-normal'>Tenant:</span> {user.tenant?.name} ({user.tenant?.tenant_type})</div>
											<div className='flex items-center gap-2 text-sub_span text-[#454545]'><span className='!font-normal'>Team Strength:</span> {user.tenant?.team_strength}</div>
											<div className='flex items-center gap-2 text-sub_span text-[#454545]'><span className='!font-normal'>Role:</span> {user.role?.name}</div>
											<div className='flex items-center gap-2 text-sub_span text-[#454545]'><span className='!font-normal'>Joined:</span> {new Date(user.createdAt).toLocaleDateString("en-IN")}</div>
										</div>
									</div>
									
									<div className="bg-white box-shadow p-5 space-y-7 rounded-md rounded-md">
										<div className='flex items-center justify-between gap-2'>
											<h3 className="text-h4 text-blue mb-0">Status</h3>
											<div
												className={`px-4 py-[5px] flex items-center gap-2 w-fit text-sub_span text-black rounded-full !font-semibold ${user.status === "active"
													? "bg-[#00D2611A] text-green-800"
													: "bg-[#F03D361A] text-red-600"
													}`}
											><span
												className={`w-[10px] h-[10px] rounded-full ${user.status === "active"
													? "bg-[#00D261]"
													: "bg-[#F03D36]"
													}`}
											></span>
												{user.status}
											</div>
										</div>
									</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
		</>
	);
};

export default TenantDetail; 